import { sanitizeHtml } from '@/shared/utils';
import { Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Options({
  props: {
    value: String,
  },
  components: {},
})
export default class HtmlTextarea extends Vue {
  value!: string;

  mounted() {
    this.updateInnerHtml();
  }

  @Watch('value')
  onValueChange() {
    this.updateInnerHtml();
  }

  private updateInnerHtml() {
    this.$el.innerHTML = sanitizeHtml(this.value, {
      ADD_ATTR: ['target'], // allow whitelisted attributes if no config is provided
    });
  }
}
